import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { first } from 'rxjs/operators';
import { RestorePasswordModel } from '../../../model/restorepasswordmodel';
import { RestorePasswordService } from '../../../service/restore-password.service';

@Component({
  selector: 'app-code-phase',
  templateUrl: './code-phase.component.html',
  styleUrls: ['./code-phase.component.css']
})
export class CodePhaseComponent implements OnInit {

    restoreCode: string;
    isValidRequest = true;
    @Input() restorePwdModel: RestorePasswordModel;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onSuccess = new EventEmitter<RestorePasswordModel>();

    constructor(private restorePwdSrv: RestorePasswordService) { }

    ngOnInit() {
    }

    next() {
        if (!this.validateRequest()) {
            return;
        }

        this.restorePwdModel.restoreCode = this.restoreCode;
        this.restorePwdSrv.check(this.restorePwdModel)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.outcome === 'OK') {
                        this.onSuccess.emit(this.restorePwdModel);
                    }
                },
                error => {
                    return;
                }
            );
    }

    private validateRequest(): boolean {
        let isValid = true;
        if (this.restoreCode == null || this.restoreCode.trim() === '') {
            this.isValidRequest = false;
            isValid = false;
        }
        return isValid;
    }

}
